"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const accordion_module_scss_1 = __importDefault(require("./accordion.module.scss"));
const pattern_library_components_icon_1 = require("@saatva-bits/pattern-library.components.icon/");
const Accordion = ({ title, subtitle, children, headingLevel = 3, titleLabel = 'accordian-title', contentLabel = 'accordian-content', className, classNameModifier, titleClassName, titleContainerClassName, subtitleClassName, titleInnerContainerClassName, iconClassName, iconContainerClassName, contentClassName, contentContainerClassName, visibleContent, isOpenOnRender = false, allowMultiOpen, singleAccordion = true, toggleContentHandler = () => { }, collapseIconName = 'less', expandIconName = 'more', customIconProps, outsideClick, onAccordionItemClick, dataSelector }) => {
    const contentEl = (0, react_1.useRef)(null);
    const [isAccordionOpen, setIsAccordionOpen] = (0, react_1.useState)((visibleContent === contentLabel) || isOpenOnRender);
    (0, react_1.useEffect)(() => {
        if (visibleContent === contentLabel) {
            setIsAccordionOpen(true);
        }
    }, [visibleContent]);
    // show/hide content based on content content height
    (0, react_1.useEffect)(() => {
        contentEl.current.style.maxHeight = !isAccordionOpen ? 0 : `${contentEl.current.scrollHeight}px`;
    }, [isAccordionOpen]);
    (0, react_1.useEffect)(() => {
        if (outsideClick && isAccordionOpen && !allowMultiOpen) {
            document.addEventListener('click', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [outsideClick, isAccordionOpen, allowMultiOpen]);
    const handleOutsideClick = (event) => {
        const isClickOutsideContent = contentEl.current && !contentEl.current.contains(event.target);
        isClickOutsideContent && setIsAccordionOpen(false);
    };
    const toggleContent = () => {
        if (onAccordionItemClick) {
            onAccordionItemClick(false);
        }
        (singleAccordion || allowMultiOpen) ? setIsAccordionOpen(!isAccordionOpen) : toggleContentHandler(contentLabel);
    };
    const Heading = `h${headingLevel}`;
    const titleContainerClasses = (0, classnames_1.default)(accordion_module_scss_1.default.titleContainer, titleContainerClassName);
    const titleInnerContainerClasses = (0, classnames_1.default)(accordion_module_scss_1.default.titleInnerContainer, titleInnerContainerClassName);
    const contentClasses = (0, classnames_1.default)(contentClassName, accordion_module_scss_1.default.content, { [accordion_module_scss_1.default.visible]: isAccordionOpen });
    const contentContainerClasses = (0, classnames_1.default)(accordion_module_scss_1.default.contentContainer, contentContainerClassName);
    let iconName = isAccordionOpen ? collapseIconName : expandIconName;
    const iconContainerClassses = (0, classnames_1.default)(accordion_module_scss_1.default.icon, iconContainerClassName);
    const iconClassNames = (0, classnames_1.default)('accordion__icon', iconClassName);
    const accordionClasses = (0, classnames_1.default)(accordion_module_scss_1.default.item, {
        [accordion_module_scss_1.default[`item--${classNameModifier}`]]: classNameModifier
    }, className);
    return ((0, jsx_runtime_1.jsxs)("div", { className: accordionClasses, "data-testid": "accordion", "data-selector": dataSelector, children: [(0, jsx_runtime_1.jsx)(Heading, { children: (0, jsx_runtime_1.jsxs)("button", { role: "button", "aria-expanded": isAccordionOpen, className: titleContainerClasses, onClick: () => toggleContent(), id: titleLabel, "aria-controls": contentLabel, children: [(0, jsx_runtime_1.jsxs)("div", { className: titleInnerContainerClasses, children: [(0, jsx_runtime_1.jsx)("span", { className: titleClassName, children: title }), (0, jsx_runtime_1.jsx)("span", { className: subtitleClassName, children: subtitle })] }), (0, jsx_runtime_1.jsx)("span", { className: iconContainerClassses, "aria-hidden": "true", children: (0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { className: iconClassNames, name: iconName, description: "Expand/Collapse", alt: iconName, ...customIconProps, titleId: "accordionIcon" }) })] }) }), (0, jsx_runtime_1.jsx)("div", { ref: contentEl, className: contentClasses, "data-testid": "region", id: contentLabel, children: (0, jsx_runtime_1.jsx)("div", { className: contentContainerClasses, children: children }) })] }));
};
Accordion.propTypes = {
    /** A string that will populate the title of the accordion item. */
    title: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.node
    ]),
    /** A string that will populate the subtitle of the accordion item, being displayed under the title */
    subtitle: prop_types_1.default.string,
    /** Content that will be rendered as children of the Accordion component. */
    children: prop_types_1.default.node,
    /** Applies a custom class to the Accordion component. */
    className: prop_types_1.default.string,
    /** This property is used to change css class names to set different styles at the item. */
    classNameModifier: prop_types_1.default.oneOf(['bgContrast1', 'bgContrastWhite']),
    /** A method used to toggle content in the Accordion component one at a time. */
    toggleContentHandler: prop_types_1.default.func,
    /** Applies a heading level to the title on the Accordion component. */
    headingLevel: prop_types_1.default.number,
    /** A boolean that determines if the content in this Accordion is open on render */
    isOpenOnRender: prop_types_1.default.bool,
    /** A boolean that allows multiple Accordions to be open at the same time */
    allowMultiOpen: prop_types_1.default.bool,
    /** A label for the title of the Accordion component. */
    titleLabel: prop_types_1.default.string,
    /** A label for the content of the Accordion component. */
    contentLabel: prop_types_1.default.string,
    /** Applies a custom class to the title in the Accordion component. */
    titleClassName: prop_types_1.default.string,
    /** Applies a custom class to the title container in the Accordion component. */
    titleContainerClassName: prop_types_1.default.string,
    /** Applies a custom class around the title and subtitle container, inside the title container */
    titleInnerContainerClassName: prop_types_1.default.string,
    /** Used when accordion is part of a set of accordions to let us know the content currently visible */
    visibleContent: prop_types_1.default.string,
    /** Applies a custom class to the icon in the Accordion component. */
    iconClassName: prop_types_1.default.string,
    /** Applies a custom class to the icon container in the Accordion component. */
    iconContainerClassName: prop_types_1.default.string,
    /** Applies a custom class to the content wrapper in the Accordion component. */
    contentClassName: prop_types_1.default.string,
    /** Applies a custom class to the content container in the Accordion component. */
    contentContainerClassName: prop_types_1.default.string,
    /** Allows the functionality to work on a single accordion item. */
    singleAccordion: prop_types_1.default.bool,
    /** Allows us to pass in custom props for the icons if needed */
    customIconProps: prop_types_1.default.object,
    /** The icon name for the collapse icon in the accordion */
    collapseIconName: prop_types_1.default.string,
    /** The icon name for the expand icon in the accordion */
    expandIconName: prop_types_1.default.string,
    /** A boolean that determines if there is a click outside the content and closes the accordion
     * (applies only if allowMultiOpen prop is not set to true)
    **/
    outsideClick: prop_types_1.default.bool,
    /** A function that triggers when an accordion item is open/closed */
    onAccordionItemClick: prop_types_1.default.func,
    dataSelector: prop_types_1.default.string
};
exports.default = Accordion;
//# sourceMappingURL=accordion.js.map